import CustomerReview, { CustomerReviewProps } from './CustomerReview';

export type { CustomerReviewProps };
export default CustomerReview;
